import React, { useState, useEffect } from 'react';
import { NavLink, Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'The Lab', path: '/lab' },
    { name: 'Insights', path: '/blog' },
    { name: 'Connect', path: '/contact' },
  ];

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'glass-panel py-4' : 'bg-transparent py-6'}`}>
      <div className="max-w-6xl mx-auto px-6 flex justify-between items-center">
        <Link to="/" className="text-xl font-bold tracking-tighter flex items-center gap-2 group">
          <div className="w-8 h-8 rounded bg-emerald-500/20 text-emerald-400 flex items-center justify-center border border-emerald-500/30 group-hover:bg-emerald-500 group-hover:text-slate-950 transition-all">
            <SafeIcon icon={FiIcons.FiCpu} />
          </div>
          <span className="text-white">Nex<span className="text-emerald-400">AI</span></span>
        </Link>

        <div className="hidden md:flex items-center space-x-8">
          {navLinks.map((link) => (
            <NavLink 
              key={link.name} 
              to={link.path}
              className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
            >
              {link.name}
            </NavLink>
          ))}
          <Link to="/contact" className="btn-primary flex items-center gap-2">
            Collaborate <SafeIcon icon={FiIcons.FiUsers} />
          </Link>
        </div>

        <button 
          className="md:hidden text-slate-300 hover:text-white"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
        >
          <SafeIcon icon={mobileMenuOpen ? FiIcons.FiX : FiIcons.FiMenu} className="text-2xl" />
        </button>
      </div>

      {mobileMenuOpen && (
        <div className="md:hidden glass-panel absolute top-full left-0 right-0 py-4 px-6 flex flex-col space-y-4 border-t-0 border-b">
          {navLinks.map((link) => (
            <NavLink 
              key={link.name} 
              to={link.path}
              onClick={() => setMobileMenuOpen(false)}
              className={({ isActive }) => `block py-2 text-lg ${isActive ? 'text-emerald-400' : 'text-slate-300'}`}
            >
              {link.name}
            </NavLink>
          ))}
          <Link to="/contact" onClick={() => setMobileMenuOpen(false)} className="btn-primary text-center mt-4">
            Collaborate
          </Link>
        </div>
      )}
    </nav>
  );
};

export default Navbar;